import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import GenreSection from "@/pages/home/components/GenreSection";
import SubtitleSection from "@/pages/home/components/SubtitleSection";
import CollectionSection from "@/pages/home/components/CollectionSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import MoodSection from "@/pages/home/components/MoodSection";
import StartGuide from "@/pages/home/components/StartGuide";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <GenreSection />
        <SubtitleSection />
        <CollectionSection />
        <TimelineSection />
        <MoodSection />
        <StartGuide />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}